const PbxxRecord = require('../pbxx_record')

module.exports = class SmartGroup extends PbxxRecord {
  static get class_name() {
    return 'SmartGroup'
  }
}
